// extracted by mini-css-extract-plugin
export default {"nav":"Header_nav__J8WFt","link":"Header_link__xIhZh","active":"Header_active__rHuVo"};